(function () {
  function rafThrottle(fn){ let id=0; return function(){ if(id) return; id=requestAnimationFrame(()=>{ id=0; fn(); }); }; }

  function init(el){
    if(el.getAttribute('data-sticky-initialized') === 'true') return;
    el.setAttribute('data-sticky-initialized','true');

    if(!el.hasAttribute('data-portalized')){
      document.body.appendChild(el);
      el.setAttribute('data-portalized','true');
    }

    el.style.display = '';

    const sectionRoot = document.getElementById(el.getAttribute('data-target-id')) || el.closest('.product-section') || document;
    const mainForm    = document.getElementById(el.getAttribute('data-main-form-id'))
                     || sectionRoot.querySelector('form[id^="AddToCartForm-"]')
                     || sectionRoot.querySelector('form[action="/cart/add"]');
    if(!mainForm) return;

    const behavior   = el.getAttribute('data-behavior') || 'add_to_cart';
    const stickyForm = el.querySelector('form');

    const getVariantIdField = () => mainForm.querySelector('input[name="id"], select[name="id"]');

    function headerOffset(){
      const h = document.querySelector('.amz-sec-hdr') || document.querySelector('.amz-hdr');
      return h ? h.offsetHeight : 0;
    }

    function setBottomOffset(){
  const vv = window.visualViewport;
  let offset = 0;
  if(vv){
    offset = Math.max(0, window.innerHeight - (vv.height + vv.offsetTop));
  }
  const prev = parseFloat(el.getAttribute('data-bottom-offset') || '0');
  if (Math.abs(prev - offset) < 2) return;
  el.setAttribute('data-bottom-offset', String(offset));
  el.style.setProperty('--sticky-atc-bottom', offset + 'px');
}


    function setFooterHide(){
      const doc = document.documentElement;
      const scrollTop = window.pageYOffset || doc.scrollTop || 0;
      const viewportH = window.innerHeight || doc.clientHeight || 0;
      const docH = Math.max(doc.scrollHeight, document.body.scrollHeight);
      const progress = docH ? (scrollTop + viewportH) / docH : 0;
      document.documentElement.classList.toggle('scrolled-to-bottom', progress >= 0.9);
    }

    const onScroll = rafThrottle(()=>{
      const rect = mainForm.getBoundingClientRect();
      const hide = rect.top > headerOffset();
      el.classList.toggle('sticky-atc--out', hide);
      setFooterHide();
      setBottomOffset();
    });

    window.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', onScroll);

    if(window.visualViewport){
      window.visualViewport.addEventListener('scroll', onScroll, {passive:true});
      window.visualViewport.addEventListener('resize', onScroll);
    }

    requestAnimationFrame(onScroll);

    const variantWrap    = el.querySelector('.sticky-atc__details__variant');
    const variantTitleEl = el.querySelector('.sticky-atc__details__variant__title');
    const optionSelects  = Array.from(el.querySelectorAll('.sticky-atc__select'));

    function syncVariantTitle(){
      if(!variantTitleEl) return;
      let txt = '';
      const firstChecked = sectionRoot.querySelector('fieldset.variant-input-wrap input[type="radio"][name]:checked');
      if(firstChecked){ txt = firstChecked.value || ''; }
      else {
        const firstSelect = sectionRoot.querySelector('fieldset.variant-input-wrap select[name]');
        if(firstSelect){
          const opt = firstSelect.options[firstSelect.selectedIndex];
          txt = (opt && opt.text) || firstSelect.value || '';
        }
      }
      variantTitleEl.textContent = txt;
      if(variantWrap) variantWrap.hidden = !txt;
    }

    function syncSelectsFromMain(){
      optionSelects.forEach(sel=>{
        const name = sel.getAttribute('data-option-name');
        const r = sectionRoot.querySelector('fieldset.variant-input-wrap input[type="radio"][name="'+name+'"]:checked');
        if(r){ sel.value = r.value; return; }
        const s = sectionRoot.querySelector('fieldset.variant-input-wrap select[name="'+name+'"]');
        if(s) sel.value = s.value;
      });
    }

    el.addEventListener('change', (e)=>{
      const sel = e.target.closest('.sticky-atc__select'); if(!sel) return;
      const name = sel.getAttribute('data-option-name'); const value = sel.value;

      const radio = sectionRoot.querySelector('fieldset.variant-input-wrap input[type="radio"][name="'+name+'"][value="'+CSS.escape(value)+'"]');
      if(radio){ if(!radio.checked) radio.checked = true; radio.dispatchEvent(new Event('change', {bubbles:true})); }

      const select = sectionRoot.querySelector('fieldset.variant-input-wrap select[name="'+name+'"]');
      if(select){ if(select.value !== value) select.value = value; select.dispatchEvent(new Event('change', {bubbles:true})); }

      burstUpdateImg();
      setTimeout(()=>{ syncVariantTitle(); syncSelectsFromMain(); },0);
    });

    const imgWrap = el.querySelector('.sticky-atc__image');
    let lastSrc = '';

    function getActiveMainImg(){
      const sels = [
        '.product__main-photos .product-main-slide.is-selected picture img',
        '.product__main-photos .product-main-slide.is-selected img',
        '.product__main-photos [aria-hidden="false"] img',
        '.product__main-photos img',
        '.product__photos img',
        '[data-product-single-media-wrapper][aria-hidden="false"] img',
        '[data-product-single-media-wrapper] img'
      ];
      for (const s of sels){
        const node = sectionRoot.querySelector(s);
        if (node && (node.currentSrc || node.src)) return node;
      }
      return null;
    }

    const updateImg = rafThrottle(()=>{
      if(!imgWrap) return;
      const img = getActiveMainImg();
      if(!img) return;

      const newSrc = img.currentSrc || img.src || '';
      if(!newSrc || newSrc === lastSrc) return;

      let stickyImg = imgWrap.querySelector('img');
      if(!stickyImg){
        stickyImg = document.createElement('img');
        stickyImg.loading = 'lazy';
        if('decoding' in stickyImg) stickyImg.decoding = 'async';
        imgWrap.innerHTML = '';
        imgWrap.appendChild(stickyImg);
      }
      stickyImg.alt = img.alt || '';
      stickyImg.src = newSrc;
      lastSrc = newSrc;

      img.addEventListener('load', ()=>{
        const latest = img.currentSrc || img.src || '';
        if(latest && latest !== lastSrc){ stickyImg.src = latest; lastSrc = latest; }
      }, { once:true });
    });

    function burstUpdateImg(){
      updateImg();
      setTimeout(updateImg, 60);
      setTimeout(updateImg, 150);
      setTimeout(updateImg, 300);
    }

    document.addEventListener('click', (e)=>{
      if(e.target.closest('.product__thumb') || e.target.closest('[data-product-thumb]')) setTimeout(burstUpdateImg, 60);
    });

    mainForm.addEventListener('change', (e)=>{
      if(e.target && (e.target.name === 'id' || e.target.closest('fieldset.variant-input-wrap'))){
        burstUpdateImg();
      }
    });

    const gallery = sectionRoot.querySelector('.product__main-photos') || sectionRoot;
    if('MutationObserver' in window && gallery){
      new MutationObserver(burstUpdateImg).observe(gallery, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['class', 'src', 'srcset', 'data-current', 'data-media-id', 'aria-hidden', 'style']
      });
    }

    function submitMain(variantId){
      let idField = getVariantIdField();
      if(!idField){ idField = document.createElement('input'); idField.type='hidden'; idField.name='id'; mainForm.appendChild(idField); }
      if(variantId) idField.value = String(variantId);

      const btn = mainForm.querySelector('button[name="add"]');
      if(typeof mainForm.requestSubmit === 'function'){
        try{ if(btn) btn.disabled=false; mainForm.requestSubmit(btn||null); }
        catch(_){ btn ? btn.click() : mainForm.submit(); }
      } else if(btn){ btn.click(); } else { mainForm.submit(); }

      setTimeout(()=>{
        const html = document.documentElement;
        const drawer = document.getElementById('CartDrawer') || document.querySelector('[id*="CartDrawer"]');
        const isOpen = html.classList.contains('js-drawer-open') || drawer?.classList.contains('is-open') || drawer?.getAttribute('aria-hidden')==='false';
        if(!isOpen && drawer){ drawer.classList.add('is-open'); html.classList.add('js-drawer-open','js-drawer-open-right'); }
      },800);
    }

    function findSelectedVariantId(){
      const idField = getVariantIdField();
      if(idField && idField.value) return String(idField.value);
      let variantsCache = null;
      const jsonEl = sectionRoot.querySelector('[data-variant-json]');
      try{ variantsCache = jsonEl ? JSON.parse(jsonEl.textContent || '[]') : []; }catch(_){ variantsCache = []; }

      const selected = [];
      sectionRoot.querySelectorAll('fieldset.variant-input-wrap').forEach(fs=>{
        const r = fs.querySelector('input[type="radio"][name]:checked');
        const s = fs.querySelector('select[name]');
        const val = r ? r.value : (s ? s.value : '');
        if(val) selected.push(val);
      });

      const v = variantsCache.find(v=>{
        if(selected[0] && v.option1 !== selected[0]) return false;
        if(selected[1] && v.option2 !== selected[1]) return false;
        if(selected[2] && v.option3 !== selected[2]) return false;
        return true;
      });
      return v ? String(v.id) : '';
    }

    function onStickySubmit(e){
      if(behavior === 'scroll') return;
      e.preventDefault();

      const vid = findSelectedVariantId();
      if(!vid){ mainForm.scrollIntoView({behavior:'smooth', block:'start'}); return; }
      submitMain(vid);
    }

    if(stickyForm) stickyForm.addEventListener('submit', onStickySubmit);

    syncVariantTitle();
    syncSelectsFromMain();
    burstUpdateImg();
    setBottomOffset();
    setFooterHide();
  }

  function initAll(){ document.querySelectorAll('sticky-atc').forEach(init); }
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
